module.exports = __webpack_public_path__ + "img/winona_deepsleep_carousel.096f6c5c.png";